import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import {faFileInvoice, faFileSignature} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios/index";
import {withStyles} from "@material-ui/core/styles/index";
import ArchiveGrid from "../../components/Archives/ArchiveGrid";

const icn = (iconType, classes) => {
    return <FontAwesomeIcon icon={iconType} className={classes.tabBarButtonIcon}/>;
}

const ArchiveIndex = ({customer, backLink, classes}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('archive.archive_customer', {customer: customer.customer_name})}
            items={[
                {
                    icon: 'arrow_back_ios',
                    text: i18n.get('boards.back'),
                    href: `/customers/${customer.id}`,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(`/customers/${customer.id}`);
                    },
                    color: 'secondary',
                }
            ]}
        />

        <ArchiveGrid appointments={customer.archived_appointments}/>

    </Layout>
);

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(ArchiveIndex);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/archives/Index.jsx